export class ImpactAssessment4 {
  //Summary Details
  //Start
  id: number;
  updatedDB_Id: number;
  geography: string;
  mappingID: string;
  country: string;
  regulator: string;
  updatedDB_Date: Date;
  pubType: string;
  title: string;
  description: string;
  hyperlink: string;
  merged_Id: string;
  isMerged: boolean;
  jurisdiction: string;
  previousImpactAsss_Id: string;
  isHidden: boolean;
  assessor: string;
  userId: string;
  userName: string;
  createdDateTime: Date;
  //End

  //Assessment Details
  //Start

  assessmentDetails: string;//Description/Objective
  ruleTopic: string;//Category
  lastUpdate: Date | null;//Date Last Update
  ruleType: string;//Binding or Non-Binding
  applicationDate: Date | null;//Foreseen Application
  assessmentStatus: string;//Actual Status/ Stage

  //*****/
  corporateGovernance: string;
  salesCs: string;
  pricingUwData: string;
  finance: string;
  peopleServices: string;
  claims: string;
  productAncillaries: string;
  euigs: string;
  marketingCommunication: string;
  aecsMadrid: string;
  dataProtection: string;
  //*****/

  complianceAssessment: string;//Admiral Seguros Compliance Monitoring
  datesDeadlines: string;
  projectReference: string;//Links with any (gold) projects 
  resourceNeeded: string;
  businessActions: string;//Admiral Seguros Bussines Action
  templateNo!: number;
  isRecordTime: boolean;
  timeSpent: number;
  compAssessment: string;

  //End
  constructor() {
    this.id = 0;
    this.updatedDB_Id = 0;
    this.geography = '';
    this.mappingID = '';
    this.country = '';
    this.regulator = '';
    this.updatedDB_Date = new Date();
    this.pubType = '';
    this.title = '';
    this.description = '';
    this.hyperlink = '';
    this.ruleTopic = '';
    this.ruleType = '';
    this.applicationDate = null;
    this.assessmentStatus = '';
    this.assessmentDetails = '';
    this.projectReference = '';
    this.merged_Id = "";
    this.isMerged = false;
    this.assessor = '';
    this.jurisdiction = '';
    this.previousImpactAsss_Id = '';
    this.lastUpdate = new Date();
    this.corporateGovernance = '';
    this.salesCs = '';
    this.pricingUwData = '';
    this.finance = '';
    this.peopleServices = '';
    this.claims = '';
    this.productAncillaries = '';
    this.euigs = '';
    this.marketingCommunication = '';
    this.aecsMadrid = '';
    this.dataProtection = '';
    this.complianceAssessment = '';
    this.datesDeadlines = '';
    this.resourceNeeded = '';
    this.businessActions = '';
    this.isHidden = false;
    this.userId = '';
    this.userName = '';
    this.createdDateTime = new Date();
    this.isRecordTime = false;
    this.timeSpent = 0;
    this.compAssessment = '';
  }
}

